import { render, staticRenderFns } from "./registor.vue?vue&type=template&id=04f69712&scoped=true&"
import script from "./registor.vue?vue&type=script&lang=js&"
export * from "./registor.vue?vue&type=script&lang=js&"
import style0 from "./registor.vue?vue&type=style&index=0&id=04f69712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f69712",
  null
  
)

export default component.exports